import { IconType } from 'react-icons'
import { TbLock, TbShieldCheck, TbInfinity, TbDashboard } from 'react-icons/tb'

export type SelfHostingBenefitsDataType = {
  Icon: IconType
  description: string
}

export const selfHostingBenefitsData: SelfHostingBenefitsDataType[] = [
  {
    Icon: TbLock,
    description: 'Customer data never leaves your environment',
  },
  {
    Icon: TbShieldCheck,
    description: 'Maintain your security and compliance standards',
  },
  {
    Icon: TbInfinity,
    description: 'No usage limits or additional charges',
  },
  {
    Icon: TbDashboard,
    description: 'Minimum latency. Maximum performance',
  },
]
